import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { fuseAnimations } from '@fuse/animations';
import { Router } from '@angular/router';


///IDIOMAS
import { lang_wizard } from 'app/idiomas/i18n/wizard/wizard.lang';
import { lang_izzi } from 'app/idiomas/i18n/Izzi/izzi.lang';
import { lang_cierre } from 'app/idiomas/i18n/cierre/cierre.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { lang_focus } from 'app/idiomas/i18n/focus/focus.lang';

//SERVICE
import { LandingService } from "./landing.service";
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
import * as $ from 'jquery';
import { productos } from './landing.productos';
//import { productos } from '../../../idiomas/i18n/perfiles/catalogos/zh2';
import { SurveyProductService } from 'app/main/wizard-cgo/survey-product/survey-product.service';

@Component({
  selector   : 'landing',
  templateUrl: './landing.component.html',
  styleUrls  : ['./landing.component.scss'],
  animations : fuseAnimations
})
export class LandingComponent implements OnInit, OnDestroy
{
  origen: any;
  cargando = true;
  claveProducto: string;
  producto: any;
  productosAsignados: any[] = [];
  instituto: string;
  idiomaVideo:string;
  listaProdsCertificar: any[] = [];
  listaProdsMedir: any[] = [];
  listaProdsPulse: any[] = [];
  listaProdsFocus: any[] = [];
  listaProdsCerAmco: any[] = [];
  idsProductosCert3Falsos = [
    {id:41, activo: false}, // medir 3.0
    {id:42, activo: false}, // pulse check 3.0
    {id:43, activo: false}, // pulse check 3.0
    {id:56, activo: false}, // AMCO
    {id:57, activo: false}, // Trabajo digno
    {id:58, activo: false}, // Primer empleo
  ];
  aniosPulsecheck:any[]=[];
  productosContratadosInter : backInter.infoProductos;
  productoPulse:boolean;
  validarVideo:boolean=true;
  productoFocus:boolean;

  //videos para MX
  video1Mx = DATOS_API.urlAssets + 'video/landing/MX/video1.mp4';
  video1MxPoster = DATOS_API.urlAssets + 'video/landing/MX/video1.jpg';
  video2Mx = DATOS_API.urlAssets + 'video/landing/MX/video2.mp4';
  video2MxPoster = DATOS_API.urlAssets + 'video/landing/MX/video2.jpg';
  btnPortalConteos:boolean= false;
  horaActualUtc:any; //variable que contiene la fecha utc0 y permitira compararconla fecha de lanzamiento

  // Private
  private _unsubscribeAll: Subject<any>;
  urlProductoPulseCheck3:any;

  //Institutos sin video presentacion
  brokersSinVideo = ['14','18','19'];
  instituto_id = localStorage.getItem('instituto_id');
  nuevosProductoAmco:boolean=true;

  constructor(
    private http:HttpClient,
    private landingService : LandingService,
    private activatedRoute:ActivatedRoute,
    private router: Router,
    private wizardService: WizardService,
    private surveyProductService: SurveyProductService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService){

      // Set the private defaults
      this._unsubscribeAll = new Subject();

      lang_wizard.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
      });

      lang_izzi.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
      });
      lang_cierre.forEach((locale) => {
          this._fuseTranslationLoaderService.loadTranslations(locale);
      });
      lang_focus.forEach((locale) => {
          this._fuseTranslationLoaderService.loadTranslations(locale);
      });



      this.translateSrv.onLangChange.subscribe(() => { this.cambiaIdiomaVideo(this.translateSrv.currentLang); });
    }

    ngOnInit(): void
    {
      this.activatedRoute.data.subscribe(params => {
        this.origen = params;
        console.log('productos',productos);

        productos.forEach( (producto) => {
          console.log('producto',producto);

          if(producto.id == this.origen.producto){
            if(localStorage.getItem("institutoValidacionEtiquetas")=="15" && this.origen.producto=="c1"){
              this.producto={
                id      : 'c1',
                title   : 'WIZARD.CERTIFICAR_C1.TITULO',
                welcome : 'WIZARD.LANDING.PRODUCTO.CERTIFICAR_C1.TITULO_ESPAIN',
                url : 'certify',
                category: 'CGO',
                length  : 30,
                updated : '9 Agosto 2019',
                start : 'WIZARD.CERTIFICAR_C1.LANDING.ENTRAR'
              }
            }
            else{
              this.producto = producto;
              //si se coloca un titulo alterno, se reemplaza el welcome por el del alterno
              if(this.origen.tituloAlterno != undefined){
                let splitTitu = this.producto.welcome.split('.');
                splitTitu[splitTitu.length - 2] = this.origen.tituloAlterno;
                let tituloAlterno = '';
                splitTitu.forEach((fragmento,i) => {
                  tituloAlterno = tituloAlterno + fragmento;
                  if(i < (splitTitu.length - 1)){
                    tituloAlterno = tituloAlterno + ".";
                  }
                });
                this.producto.welcome = tituloAlterno;
              }
            }
          }
        });
      console.log(this.producto);

        this.obtieneInstituto();
        this.obtieneProductos();
        localStorage.removeItem('tipoproductoID');
        localStorage.removeItem('surveyProductoFocus');
        localStorage.removeItem('tipoProducto');
        localStorage.removeItem('accesoPortalLanding');


      });

      if(localStorage.getItem('tipoIzzi')){
        this.validarVideo=false;
      }
      else{
        this.validarVideo=true;
      }

      this.horaActualUtc0();
    }

    ngOnDestroy(): void
    {
      // Unsubscribe from all subscriptions
      this._unsubscribeAll.next();
      this._unsubscribeAll.complete();
    }
    cambiaIdiomaVideo(idioma:string){
      this.idiomaVideo = this.translateSrv.currentLang;
      switch(idioma){
        case 'es': this.idiomaVideo = idioma; break;
        default: this.idiomaVideo = 'en';
      }

      if(this.idiomaVideo == 'es'){
        if (localStorage.getItem("institutoValidacionEtiquetas")=='2') {
            $("#videoLanding").attr("src",DATOS_API.urlAssets + 'video/landing/CAYC/certify.mp4');
            console.log(DATOS_API.urlAssets + 'video/landing/CAYC/certify.mp4');
        }else{
          console.log("No es instituto  CARCA");
          $("#videoLanding").attr("src",DATOS_API.urlAssets + 'video/landing/TODOS/' + this.claveProducto + '.mov');
          console.log(DATOS_API.urlAssets + 'video/landing/TODOS/' + this.claveProducto + '.mov');
          $("#videoLanding").attr("poster",DATOS_API.urlAssets + 'video/landing/TODOS/' + this.claveProducto + '.jpg');
        }
      }
      else{
        if (localStorage.getItem("institutoValidacionEtiquetas")=='2') {
          $("#videoLanding").attr("src",DATOS_API.urlAssets + 'video/landing/CAYC/certify_en.mp4');
          console.log(DATOS_API.urlAssets + 'video/landing/CAYC/certify_en.mp4');
        }else{
          console.log("No es instituto  CARCA");

          $("#videoLanding").attr("src",DATOS_API.urlAssets + 'video/landing/TODOS/certify_' + this.idiomaVideo + '.mp4');
          $("#videoLanding").attr("poster",DATOS_API.urlAssets + 'video/landing/TODOS/certify_' + this.idiomaVideo + '.jpg');
        }
      }
    }

    obtieneInstituto(){
      let institutoAct = this.wizardService.getInstituto();
      console.log(institutoAct);
      switch(institutoAct){
        case '1': case 'MX': this.instituto = 'MX'; break;
        case '2': case 'CAyC': this.instituto = 'CAyC'; break;
        case '3': case 'HK': this.instituto = 'HK'; break;
        case '4': case 'SGP': this.instituto = 'SGP'; break;
        case '5': case 'TK': this.instituto = 'TK'; break;
        case '6': case 'FL': this.instituto = 'FL'; break;
        case '8': case 'IZZI': this.instituto = 'IZZI'; break;
        case '11': case 'BR': this.instituto = 'BR'; break;
        case '14': case 'GCTI': this.instituto = 'GCTI'; break;
        case '15': case 'ES': this.instituto = 'ES'; break;
        case '18': case 'AMCO': this.instituto = 'AMCO'; break;
        case '19': case 'AMCO': this.instituto = 'GCTI'; break;
        case '22': case 'HK2': this.instituto = 'HK2'; break;
      }
    }



    horaActualUtc0(){
      let moment = require('moment');
    let horaActual = moment().utc(true);
    let difUtc = moment.parseZone(moment().format()).utcOffset();
    let horaActualUTC0: any;
    if(difUtc < 0){
      horaActualUTC0 = horaActual.clone().subtract(difUtc,'minutes');
    }
    else{
      horaActualUTC0 = horaActual.clone().add(difUtc,'minutes');
    }
    console.log("horaInstForma:",horaActual.clone().format());
    console.log("difUTC0:",difUtc);
    console.log("horaUTC0:",horaActualUTC0.format());
    this.horaActualUtc=horaActualUTC0.format();
    console.log("sjdisa: ",this.horaActualUtc);
    return horaActualUTC0.format();

  }


    borrarDatoSurveyProduct(){
      console.log('ejecutar eliminar info');
      this.surveyProductService.eliminarInfoSurveyProduct("100");
    }








    obtieneProductos(){
      this.wizardService.getProductos().subscribe( (respuesta: any) => {
        this.productosContratadosInter = respuesta;
        console.log(this.productosContratadosInter);
        let prods: any;
        let url: string;
        let nombre: string;
        this.filtraProductosMedir(respuesta);

        console.log("Origen de productos");
        console.log(this.origen.producto);
        localStorage.setItem('tipoProducto', this.origen.producto);
        switch(this.origen.producto){
          // case '1': prods = respuesta.productosCertificar; url = 'certify'; nombre = 'CERTIFICAR'; break;
          case '1': prods = this.listaProdsCertificar[0].lista; url = '/certify/wizard/'; nombre = 'CERTIFICAR'; this.claveProducto = 'certify'; break;
          case '2': prods = respuesta.productosMedir; url = '/measurement/wizard/'; nombre = 'MEDIR'; this.claveProducto = 'measurement'; break;
          case '3':
            this.pulseCheckAños();
            // prods = respuesta.productosPulseCheck; url = 'pulse/adminpulsecheck/'; nombre = 'PULSE';
            prods = this.listaProdsPulse[0].lista; url = 'pulse/adminpulsecheck/'; nombre = 'PULSE';
            this.productoPulse=true; this.productoFocus=false; this.claveProducto = 'pulse'; this.urlProductoPulseCheck3='pulse/adminpulsecheck/';
          break;
          // PULSE CHECK 3.0
          case 'p1':
          this.borrarDatoSurveyProduct();
          this.pulseCheckAños3();
            prods = this.listaProdsPulse[1].lista; url = 'pulse_t1/adminpulsecheck/'; nombre = 'PULSE_T1';
            this.productoPulse=true; this.productoFocus=false;this.claveProducto = 'pulse'; this.urlProductoPulseCheck3= 'pulse_t1/adminpulsecheck/'
          break;
          // Focus Area 3.0
          case 'f1':
          this.borrarDatoSurveyProduct();
          this.focusAreaAños3();
            prods = this.listaProdsFocus[1].lista; url = 'focus_t1/adminpulsecheck/'; nombre = 'FOCUS_1';
            this.productoPulse=true; this.productoFocus=true;this.claveProducto = 'focus'; this.urlProductoPulseCheck3= 'focus_t1/adminpulsecheck/'
          break;

          case '4': prods = respuesta.productosFocusArea; url = '/focus/wizard/'; nombre = 'FOCUS'; this.claveProducto = 'focus'; break;
          //CASOS PRODUCTOS CERTIFICAR NUEVOS
          case 'c1': prods = this.listaProdsCertificar[1].lista; url = '/certify_t1/wizard/';
            if(localStorage.getItem("institutoValidacionEtiquetas")!="15"){
              nombre = 'CERTIFICAR';
            }
            else{
              nombre = 'CERTIFICAR_ESPAIN';
            }
            this.claveProducto = 'certify';
          break;
          //CASOS PRODUCTOS CERTIFICAR 3 NUEVO INSTITUTO
          case 'c2': prods = this.listaProdsCertificar[2].lista; url = '/certify_t2/wizard/'; nombre = 'IZZI'; this.claveProducto = 'certify'; break;
          case 'c3': prods = this.listaProdsCertificar[3].lista; url = '/certify_t3/wizard/'; nombre = 'CERTIFICAR'; this.claveProducto = 'certify'; this.borrarDatoSurveyProduct(); break;
          case 'c4Plata': prods = this.listaProdsCertificar[4].lista; url = '/certify_t4/wizard/'; nombre = 'CERTIFICAR'; this.claveProducto = 'certify'; this.borrarDatoSurveyProduct(); break;
          case 'c6': prods = this.listaProdsCertificar[5].lista; url = '/certify_t6/wizard/'; nombre = 'CERTIFICAR_C6'; this.claveProducto = 'certify'; this.borrarDatoSurveyProduct(); break;
          //CASOS PRODUCTOS MEDIR NUEVOS
          case 'm1': prods = this.listaProdsMedir[1].lista; url = '/measurement_t1/wizard/'; nombre = 'MEDIR_M1'; this.claveProducto = 'measurement'; break;
          case 'm2': prods = this.listaProdsMedir[2].lista; url = '/measurement_t2/wizard/'; nombre = 'MEDIR_M2'; this.claveProducto = 'measurement'; break;
          case 'm3': prods = this.listaProdsMedir[3].lista; url = '/measurement_t3/wizard/'; nombre = 'MEDIR_M3'; this.claveProducto = 'measurement'; break;
          case 'm4': prods = this.listaProdsMedir[4].lista; url = '/measurement_t4/wizard/'; nombre = 'MEDIR_M4'; this.claveProducto = 'measurement'; break;
          case 'm5': prods = this.listaProdsMedir[5].lista; url = '/measurement_t5/wizard/'; nombre = 'MEDIR_M5'; this.claveProducto = 'measurement'; break;
          case 'm6': prods = this.listaProdsMedir[6].lista; url = '/measurement_t6/wizard/'; nombre = 'MEDIR_M6'; this.claveProducto = 'measurement'; break;
          case 'm7':
            prods = this.listaProdsMedir[7].lista; url = '/measurement_t7/wizard/';
            nombre = this.origen.tituloAlterno != undefined ? this.origen.tituloAlterno : 'MEDIR_M7';
            this.claveProducto = 'measurement';
            this.borrarDatoSurveyProduct();
          break;
          case 'm8':
            prods = this.listaProdsMedir[7].lista; url = '/measurement_t8/wizard/';
            nombre = this.origen.tituloAlterno != undefined ? this.origen.tituloAlterno : 'MEDIR_M8';
            this.claveProducto = 'measurement';
            this.borrarDatoSurveyProduct();
          break;
          case 'm9':
            prods = this.listaProdsMedir[7].lista; url = '/measurement_t9/wizard/';
            nombre = this.origen.tituloAlterno != undefined ? this.origen.tituloAlterno : 'MEDIR_M9';
            this.claveProducto = 'measurement';
            this.borrarDatoSurveyProduct();
          break;
          case 'am1': prods = this.listaProdsCerAmco[0].lista; url = '/amco_1/wizard/'; nombre = 'Amco'; this.claveProducto = 'Amco'; this.borrarDatoSurveyProduct(); this.nuevosProductoAmco=false; break;
            case 'td1': prods = this.listaProdsCerAmco[1].lista; url = '/traba_digno/wizard/'; nombre = 'Trabajo_digno'; this.claveProducto = 'Trabajo digno'; this.borrarDatoSurveyProduct();this.nuevosProductoAmco=false; break;
            case 'pe1': prods = this.listaProdsCerAmco[2].lista; url = '/prime_emple/wizard/'; nombre = 'Primer_empleo'; this.claveProducto = 'Primer empleo'; this.borrarDatoSurveyProduct();this.nuevosProductoAmco=false; break;
        }
        prods = this.ordenaDescendente(prods, this.origen.producto);
        // console.log(prods);
        this.colocaProductos(nombre,url,this.instituto,prods);
        this.cambiaIdiomaVideo(this.translateSrv.currentLang);
      });
    }

    ordenaDescendente(datos:any, tipo:string){
      switch(tipo){
        case '1': case 'c1': case 'c2': case 'c3': case 'm7': case 'p1': case 'm8': case 'am1': case 'td1': case 'pe1':case'm9':case'c4Plata': datos.sort( (a,b) => { if(a.fechaCertificar < b.fechaCertificar){ return 1; } else{ return -1; } }); break;
        case '2': datos.sort( (a,b) => { if(a.fechaMedir < b.fechaMedir){ return 1; } else{ return -1; } }); break;
        case '3': datos.sort( (a,b) => { if(a.fechaPulseCheck < b.fechaPulseCheck){ return 1; } else{ return -1; } });
        break;
        case '4': datos.sort( (a,b) => { if(a.fechaFocus < b.fechaFocus){ return 1; } else{ return -1; } }); break;
        default: datos.sort( (a,b) => { if(a.fechaProducto < b.fechaProducto){ return 1; } else{ return -1; } });
      }
      return datos;
    }

    colocaProductos(producto:string, url:string, instituto:string, datos:any){
      let moment = require('moment');
      let fechaActual = moment().format('YYYY/MM/DD HH:mm:ss');
      console.log("esta fecha es la que hoy ",fechaActual);
      console.log("producto",producto);

      console.log(datos);
      datos.forEach( (elem) => {
        let fecha:number;
        let idProducto:string;
        let completo: number;
        let tagStatus: string;
        let nombreProducto:string;
        let encuestaActiva:string;
        let modifUrlShort:boolean;
        let closeNotice:boolean;
        let selectNotice1:boolean;
        let selectNotice2:boolean;
        let fechaLanzamiento= moment(elem.fechaLanzamiento).format('YYYY/MM/DD HH:mm:ss');
        console.log(this.horaActualUtc);
        let fechaPortal= moment(this.horaActualUtc).isAfter(moment(elem.fechaLanzamiento));
        console.log(fechaPortal);

        if(fechaPortal){
          // console.log("econtro 1");

        this.btnPortalConteos=true;
      }else{
        this.btnPortalConteos=false;
      }

        switch(producto){
          case 'CERTIFICAR': case 'IZZI': case 'CERTIFICAR_ESPAIN': case 'MEDIR_M7': case 'PULSE_T1': case 'MEDIR_M8': case 'Amco': case 'Trabajo_digno': case 'Primer_empleo': case 'MEDIR_M9': case 'CERTIFICAR_C6':
          fecha = elem.fechaCertificar; idProducto = elem.idCertificar;nombreProducto=elem.nombreProducto; fechaLanzamiento=elem.fechaLanzamiento;
          completo = elem.completoCertificar; encuestaActiva=elem.openSurvey;
          if (elem.surveyProductId) {
            closeNotice=elem.surveyProductId.config.closeNotice;
            selectNotice1=elem.surveyProductId.config.selectNotice1;
            selectNotice2=elem.surveyProductId.config.selectNotice2;
            modifUrlShort=elem.surveyProductId.config.customSurveyUrl;
          }else{
            console.log('entro producto viejo');
            modifUrlShort=true;
            closeNotice=true;
            selectNotice1=true;
            selectNotice2=true;
          }

          console.log("Estatus Encuesta nuevo",encuestaActiva);
          console.log("modifUrlShort",modifUrlShort);

          break;
          case 'MEDIR':
          fecha = elem.fechaMedir; idProducto = elem.idMedir;nombreProducto=elem.nombreProducto; fechaLanzamiento=elem.fechaLanzamiento;
          completo = elem.completoMedir; encuestaActiva=elem.openSurvey;
          break;
          case 'PULSE':
          fecha = elem.fechaPulseCheck; idProducto = elem.idPulseCheck; nombreProducto=elem.nombreProducto; fechaLanzamiento=elem.fechaLanzamiento;
          completo = elem.completoPulseCheck; encuestaActiva=elem.openSurvey;

          break;
          case 'FOCUS':
          fecha = elem.fechaFocus; idProducto = elem.idFocusArea;
          completo = elem.completoFocusArea; encuestaActiva=elem.openSurvey;
          break;
          case 'MEDIR_M1': case 'MEDIR_M2': case 'MEDIR_M3': case 'MEDIR_M4': case 'MEDIR_M5': case 'MEDIR_M6':
          console.log('elem.nombreProducto',elem.nombreProducto);

          fecha = elem.fechaProducto; idProducto = elem.idProducto; nombreProducto=elem.nombreProducto; fechaLanzamiento=elem.fechaLanzamiento;
          completo = elem.completo; encuestaActiva=elem.openSurvey;

          if (elem.surveyProductId) {
            closeNotice=elem.surveyProductId.config.closeNotice;
            selectNotice1=elem.surveyProductId.config.selectNotice1;
            selectNotice2=elem.surveyProductId.config.selectNotice2;
            modifUrlShort=elem.surveyProductId.config.customSurveyUrl;
          }else{
            console.log('entro producto viejo');
            modifUrlShort=true;
            closeNotice=true;
            selectNotice1=true;
            selectNotice2=true;
          }
          break;
        }
        let tagTextPrincipal='WIZARD.LANDING.PRODUCTO.'+producto+'.CURRENT';
        switch(completo){
          case 1:
          tagStatus =  localStorage.getItem('instituto_id') == '19' ? 'WIZARD.LANDING.PRODUCTO.MEDIR_M9.CURRENT' : tagTextPrincipal;
          break;
          default: tagStatus = 'WIZARD.LANDING.PRODUCTO.'+producto+'.FINISHED';
        }

        let titleProduc='WIZARD.'+producto+'.TITULO';

        this.productosAsignados.push(
          {
            category: 'CGO',
            length  : 30,
            title   : localStorage.getItem('instituto_id') == '19' ? 'WIZARD.MEDIR_M9.TITULO' : titleProduc,
            date : fecha,
            url : url,
            instituto : instituto,
            productoID : idProducto,
            start : 'WIZARD.LANDING.ENTRAR',
            completo,
            tagStatus,
            nombreProducto: nombreProducto,
            fechaLanzamiento:fechaLanzamiento,
            banderaBtnPortal:this.btnPortalConteos,
            encuestaActiva:encuestaActiva,
            modifUrlShort:modifUrlShort,
            closeNotice:closeNotice,
            selectNotice1:selectNotice1,
            selectNotice2:selectNotice2,


          }
        );
      });
      console.log(this.productosAsignados);
      this.cargando = false;
    }

    filtraProductosMedir(productos:backInter.infoProductos){
      this.listaProdsCertificar = [];
      this.listaProdsMedir = [];
      this.listaProdsPulse = [];
      this.listaProdsFocus = [];
      this.listaProdsCerAmco = [];
      //arreglos certificar
      let arrayCert_1:any[] = [];
      let arrayCert_2:any[] = [];
      let arrayCert_3:any[] = [];
      let arrayCert_4:any[] = [];
      let arrayCert_5:any[] = [];
      let arrayCert_6:any[] = [];
      //declaración de arreglos de productos medir
      let arrayMedir_0:any[] = [];
      let arrayMedir_1:any[] = [];
      let arrayMedir_2:any[] = [];
      let arrayMedir_3:any[] = [];
      let arrayMedir_4:any[] = [];
      let arrayMedir_5:any[] = [];
      let arrayMedir_6:any[] = [];
      let arrayMedir_7:any[] = [];
      let arrayPulse_0:any[] = [];
      let arrayPulse_1:any[] = [];
      let arrayFocus_0:any[] = [];
      let arrayFocus_1:any[] = [];
      let arrayCerAmco:any[] = [];
      let arrayCerTraDig:any[] = [];
      let arrayCerPriEmp:any[] = [];
      //declaración de arreglos de productos pulse

      //filtrado de certificar
      productos.productosCertificar.forEach((producto:any) => {
        if(this.idsProductosCert3Falsos.findIndex(item => item.id == producto.idProducto) == -1){ //si el id del producto no esta en el arreglo
          switch (producto.tipo) {
            case 1: arrayCert_1.push(producto); break;
            case 2: arrayCert_2.push(producto); break;
            case 3: arrayCert_3.push(producto); break;
            case 4: arrayCert_4.push(producto); break;
            case 9: arrayCert_5.push(producto); break;
            case 11: arrayCert_6.push(producto); break;
          }
        }
        else{
          switch (producto.idProducto) {
            case 41:  //medir 3.0
              arrayMedir_7.push(producto);
              this.idsProductosCert3Falsos[0].activo = true;
            break;
            case 42:  //pulse 3.0
              arrayPulse_1.push(producto);
              this.idsProductosCert3Falsos[1].activo = true;
            break;
            case 43:  //pulse 3.0
              arrayFocus_1.push(producto);
              this.idsProductosCert3Falsos[2].activo = true;
            break;
            case 56:  //pulse 3.0
              arrayCerAmco.push(producto);
              this.idsProductosCert3Falsos[3].activo = true;
            break;
            case 57:  //pulse 3.0
              arrayCerTraDig.push(producto);
              this.idsProductosCert3Falsos[4].activo = true;
            break;
            case 58:  //pulse 3.0
              arrayCerPriEmp.push(producto);
              this.idsProductosCert3Falsos[5].activo = true;
            break;
          }
        }
      });
      //filtrado de medir
      productos.productosMedir.forEach(producto => {
        arrayMedir_0.push(producto);
      });
      productos.productosMedir2.forEach(producto => {
        switch(producto.tipo){
          case 1: arrayMedir_1.push(producto); break;
          case 2: arrayMedir_2.push(producto); break;
          case 3: arrayMedir_3.push(producto); break;
          case 4: arrayMedir_4.push(producto); break;
          case 5: arrayMedir_5.push(producto); break;
          case 6: arrayMedir_6.push(producto); break;
        }
      });

      //filtrado de pulse
      productos.productosPulseCheck.forEach(producto => {
        arrayPulse_0.push(producto);
      });
      //filtrado de Focus area
      productos.productosFocusArea.forEach(producto => {
        arrayFocus_0.push(producto);
      });

      this.listaProdsCertificar.push(
        {id:1, lista: arrayCert_1},
        {id:20, lista: arrayCert_2},
        {id:27, lista: arrayCert_3},
        {id:40, lista: arrayCert_4},
        {id:69, lista: arrayCert_5},
        {id:75, lista: arrayCert_6},
      );
      this.listaProdsCerAmco.push(
        {id:56, lista: arrayCerAmco},
        {id:57, lista: arrayCerTraDig},
        {id:58, lista: arrayCerPriEmp},
      );

      this.listaProdsMedir.push(
        {id:2, lista: arrayMedir_0},
        {id:11, lista: arrayMedir_1},
        {id:12, lista: arrayMedir_2},
        {id:13, lista: arrayMedir_3},
        {id:14, lista: arrayMedir_4},
        {id:15, lista: arrayMedir_5},
        {id:16, lista: arrayMedir_6},
        {id:41, lista: arrayMedir_7}, //medir 3.0
      );

      this.listaProdsPulse.push(
        {id:4, lista: arrayPulse_0},
        {id:42, lista: arrayPulse_1},
      );
      this.listaProdsFocus.push(
        {id:6, lista: arrayFocus_0},
        {id:43, lista: arrayFocus_1},
      );
    }

    private navigateTo(ruta,fecha,instituto,productoID,modifUrlShort,closeNotice,selectNotice1,selectNotice2){
      console.log("navigateTo ruta:",ruta);

      localStorage.setItem('fechaProducto', fecha);
      localStorage.setItem('instituto', instituto);
      localStorage.setItem('productoID', productoID);
      ////Variables para los requerimientos tecnicos/////
      localStorage.setItem('fechaProductoRequerimientos', fecha);
      localStorage.setItem('institutoRquerimientos', instituto);
      localStorage.setItem('productoIDRequerimientos', productoID);
      localStorage.setItem('tipoProductoRequerimientos', this.origen.producto);
      localStorage.setItem('tipoProducto', this.origen.producto);
      localStorage.setItem('modifUrlShort', modifUrlShort);
      localStorage.setItem('closeNotice', closeNotice);
      localStorage.setItem('selectNotice1', selectNotice1);
      localStorage.setItem('selectNotice2', selectNotice2);
      console.log(localStorage.getItem('modifUrlShort'));

      this.router.navigate([ruta]);
    }

    navigateToPulsos(ruta,fecha){
      localStorage.setItem('fechaProducto', fecha);
      this.router.navigate([ruta]);
    }



    pulseCheckAños(){
      let fechaActual:number;
      let fechaPulse:any[]=[];
      this.productosContratadosInter.productosPulseCheck.sort( (a,b) => {
        if(b.fechaPulseCheck > a.fechaPulseCheck){
          return 1;
        } else{
          return -1;
        }
      });
      this.productosContratadosInter.productosPulseCheck.forEach((element,i) => {
        if(fechaActual){
          if(element.fechaPulseCheck == fechaActual){
            fechaPulse.push(element);
          }
          else {
            this.aniosPulsecheck.push({fecha: fechaActual, datos: fechaPulse });
            fechaPulse=[];
            fechaActual=element.fechaPulseCheck;
            fechaPulse.push(element);
          }
        }
        else{
          fechaActual=element.fechaPulseCheck;
          fechaPulse.push(element);
        }
        fechaPulse.sort( (a,b) => {
          if(a.numero > b.numero){ return 1; } else{ return -1; }
        });
        if(this.productosContratadosInter.productosPulseCheck.length ==(i+1)){
          this.aniosPulsecheck.push({fecha: element.fechaPulseCheck, datos: fechaPulse });
        }
      });
      console.log(this.aniosPulsecheck);
    }

    pulseCheckAños3(){
      console.log("Entro este visne del 3");

      let fechaActual:number;
      let fechaPulse:any[]=[];
      let pulseV3:any[]=[];
      this.productosContratadosInter.productosCertificar.forEach((element) => {
        if (element.idProducto==42) {
         pulseV3.push(element);
        }

      });

      pulseV3.sort( (a,b) => {
        if(b.fechaCertificar > a.fechaCertificar){
          return 1;
        } else{
          return -1;
        }
      });


      pulseV3.forEach((element,i) => {
        console.log("entro producto pulsechek 3.0");
        if(fechaActual){
          console.log('entro fechaActual true ');

          if(element.fechaCertificar == fechaActual){
            fechaPulse.push(element);
          }
          else {
            this.aniosPulsecheck.push({fecha: fechaActual, datos: fechaPulse });
            fechaPulse=[];
            fechaActual=element.fechaCertificar;
            fechaPulse.push(element);
          }
        }
        else{
          console.log('entro fechaActual true ');
          fechaActual=element.fechaCertificar;
          fechaPulse.push(element);

        }

        fechaPulse.sort( (a,b) => {
          if(a.numPulse > b.numPulse){ return 1; } else{ return -1; }
        });
        console.log(fechaPulse);
        if(pulseV3.length ==(i+1)){
          console.log('si entro jdsfsdasmdka');
          this.aniosPulsecheck.push({fecha: element.fechaCertificar, datos: fechaPulse });
      }
      });
      console.log(this.aniosPulsecheck);
    }

    focusAreaAños3(){
      console.log("Entro este visne del 3");

      let fechaActual:number;
      let fechaFocus:any[]=[];
      let focusV3:any[]=[];
      this.productosContratadosInter.productosCertificar.forEach((element) => {
        if (element.idProducto==43) {
         focusV3.push(element);
        }

      });

      focusV3.sort( (a,b) => {
        if(b.fechaCertificar > a.fechaCertificar){
          return 1;
        } else{
          return -1;
        }
      });


      focusV3.forEach((element,i) => {
        console.log("entro producto pulsechek 3.0");
        if(fechaActual){
          console.log('entro fechaActual true ');

          if(element.fechaCertificar == fechaActual){
            fechaFocus.push(element);
          }
          else {
            this.aniosPulsecheck.push({fecha: fechaActual, datos: fechaFocus });
            fechaFocus=[];
            fechaActual=element.fechaCertificar;
            fechaFocus.push(element);
          }
        }
        else{
          console.log('entro fechaActual true ');
          fechaActual=element.fechaCertificar;
          fechaFocus.push(element);

        }

        fechaFocus.sort( (a,b) => {
          if(a.numPulse > b.numPulse){ return 1; } else{ return -1; }
        });
        console.log(fechaFocus);
        if(focusV3.length ==(i+1)){
          console.log('si entro jdsfsdasmdka');
          this.aniosPulsecheck.push({fecha: element.fechaCertificar, datos: fechaFocus });
      }
      });
      console.log(this.aniosPulsecheck);
    }



    obtenerProductoId(productoID,fecha){
      let inicio='accesoPortalLanding'
      console.log("entro este visne ");
      localStorage.setItem('productoID', productoID);
      localStorage.setItem('tipoProducto', this.origen.producto);
      localStorage.setItem('fechaProducto', fecha);
      localStorage.setItem('accesoPortalLanding', inicio);

  }

}
